import { mapActions } from 'vuex';
import cmsContentMixin from '@/mixins/cmsContent';


export const DAILY_PAGES = {
  MONDAY: {
    id: 'market-focus',
    path: '/market-focus',
    pageId: 'DailyMarketsMonday',
    title: 'Market Focus',
  },
  TUESDAY: {
    id: 'daily-market-updates',
    path: '/daily-market-updates',
    pageId: 'DailyMarketsTuesday',
    title: 'Daily Market Updates',
  },
  WEDNESDAY: {
    id: 'daily-markets-wednesday',
    path: '/daily-markets-wednesday',
    pageId: 'DailyMarketsWednesday',
    title: 'Daily Markets Wednesday',
  },
  THURSDAY: {
    id: 'daily-markets-thursday',
    path: '/daily-markets-thursday',
    pageId: 'DailyMarketsThursday',
    title: 'Daily Markets Thursday',
  },
};


export default {
  mixins: [
    cmsContentMixin,
  ],
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  metaInfo() {
    const info = Object.values(DAILY_PAGES)
    const pageData = info.find(i => i.pageId === this.pageId)

    return {
      title: (pageData || {}).title || 'Daily Markets',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(this.pageId)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-daily-markets-details/page-daily-markets-details.js